// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"abe95f78","633":"8a405010","816":"6fdd851b"}[chunkId] + ".chunk.js";
};